// Accordion labels switched to sentence case (acronyms kept).
import React, { FC, ReactNode } from 'react';

import { Accordion, Box, HStack } from '@chakra-ui/react';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { ButtonGroup } from 'components/DataEntry';
import { ButtonGroupItem } from 'components/DataEntry/Button/ButtonGroup';
import { MetaAccordionItem } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetaAccordionItem';

interface Props {
  isLoading: boolean;
  privilegeItems: ButtonGroupItem[];
  activePrivilege?: string;
  onSelectPrivilege: (privilege: string) => void;
  panel: ReactNode;
}

// Keep the privilege selector layout separate from the data-fetching view so
// changes to this accordion do not add more rendering logic to IdentityPermissions.
export const PermissionDetails: FC<Props> = ({
  isLoading,
  privilegeItems,
  activePrivilege,
  onSelectPrivilege,
  panel,
}) => (
  <Accordion allowMultiple defaultIndex={[0]}>
    <MetaAccordionItem
      isLoading={isLoading}
      label={
        <HStack justify="space-between" w="full">
          <HStack spacing={3}>
            <FilterLabelWrapper>Privileges</FilterLabelWrapper>
            <Box
              overflowX="auto"
              py={0.5}
              onClick={event => event.stopPropagation()}
            >
              <ButtonGroup
                items={privilegeItems}
                value={privilegeItems.find(
                  item => item.value === activePrivilege,
                )}
                onClick={item => onSelectPrivilege(item.value)}
              />
            </Box>
          </HStack>
        </HStack>
      }
      panel={panel}
      height="510px"
    />
  </Accordion>
);
